import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { Iobject, Ioption } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import Select from 'components/Material/Select';
// component
import { getFindDropDownUserType, getFindUserByAspUserId } from 'main_api';
import UserListModal from 'components/Modal/UserListModal';
import Alert from '@material-ui/lab/Alert';
import Header from 'components/Header';
import Menu from '../../../components/Menu';
import { inputChange, selectChange } from '../../../main_func';
import Input from '../../../components/Material/Input';
import { VcEGrid, VcGrid } from '../../../components/Grid';
import { getUserInfoRedux } from '../../../reducers/shareData/selector';
import Table from '../../../components/Material/Table/index';
import { Imaster, IuserInfo, IuserType } from './type';

/** 使用者功能權限設定作業 */
const AspUserMtn = (): JSX.Element => {
  const apiName = 'aspUserMtn';
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);
  const { user } = useSelector(getUserInfoRedux);
  const masterDefaultValue: Imaster = {
    aspUserId: '',
    userType: '',
    userName: '',
  };
  const [master, setMaster] = useState(masterDefaultValue);
  const [, setExpressName] = useState('');
  const [, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('edit');
  const [rowData] = useState<Imaster[]>([]);
  const [colList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [userInfoList, setUserInfoList] = useState<Ioption[]>([]);
  const [userTypeList, setUserTypeList] = useState<Ioption[]>([]);
  // 如果用戶代碼查到兩筆以上的資料，打開modal讓使用者選擇
  const [openAspModal, setOpenAspModal] = useState(false);
  const [aspUserIdCheck, setAspUserIdCheck] = useState('');
  const [userInfoMsg, setUserInfoMsg] = useState('');

  /** 查詢(編輯) */
  const handleAdd = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    // TODO API
    dispatch(setLoadingRedux(false));
  };

  /** 新增 */
  const handleEdit = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    // TODO API
    dispatch(setLoadingRedux(false));
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.aspUserId.length > 0) {
      switch (submitKey) {
        case 'edit':
          handleEdit();
          break;
        case 'add':
          handleAdd();
          break;
        default:
          break;
      }
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
  };

  const handleReset = () => {
    setMaster(masterDefaultValue);
    setExpressName('');
    setWarehouseName('');
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  const getUserInfo = async (aspUserId: string) => {
    // #region 如果欄位為空 || 與上一次的值一樣 return
    if (aspUserId === aspUserIdCheck) {
      setAspUserIdCheck(aspUserId);
      return;
    }
    setAspUserIdCheck(aspUserId);
    // #endregion
    dispatch(setLoadingRedux(true));
    const result = await getFindUserByAspUserId(apiName, {
      aspUserId,
    });
    dispatch(setLoadingRedux(false));
    const resultData: IuserInfo[] = result.data.data as IuserInfo[];
    if ((resultData || []).length > 0) {
      // 如果查到多筆，顯示modal、寫入 setUserInfoList
      if (resultData.length > 1) {
        setOpenAspModal(true);
        setUserInfoList(
          resultData.map((val) => ({
            value: val.extId,
            label: `${val.extId}(${val.userName})`,
          }))
        );
      } else {
        // 代入使用者名稱
        updateData({ userName: resultData[0].userName });
      }
    } else {
      updateData({ userName: '' });
      setUserInfoMsg(result.data.msg);
    }
  };

  const getUserType = async () => {
    dispatch(setLoadingRedux(true));
    const result = await getFindDropDownUserType(apiName);
    dispatch(setLoadingRedux(false));
    const resultData: IuserType[] = result.data.data as IuserType[];
    if ((resultData || []).length > 0) {
      // 如果查到多筆，顯示modal
      setUserTypeList(
        resultData.map((val) => ({
          value: val.usertype,
          label: `${val.name}(${val.usertype})`,
        }))
      );
    }
  };

  useEffect(() => {
    setMaster(masterDefaultValue);
    getUserType();
  }, []);

  return (
    <>
      <div id="page-area">
        <Header />
        <div className="breadcrumbs-area">
          {/* <Breadcrumbs>
            <Link
              className="icon-item"
              color="inherit"
              href="/"
              onClick={breadClick}
            >
              <HomeIcon className="icon" />
              首頁
            </Link>
            <Link
              color="inherit"
              href="/getting-started/installation/"
              onClick={breadClick}
            >
              進出倉作業查詢
            </Link>
            <Typography color="textPrimary">使用者功能權限設定作業</Typography>
          </Breadcrumbs> */}
        </div>
        <form onSubmit={handleSubmit} className="form-area">
          <div>
            <div className="title">
              <EditIcon /> 使用者功能權限設定作業
            </div>
          </div>
          <div className="input-area">
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                ASP用戶代碼：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  maxLength={35}
                  value={master.aspUserId}
                  name="aspUserId"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                  onBlur={(e) => {
                    getUserInfo(e.target.value);
                  }}
                />
              </Grid>
              <VcGrid item xs={12} sm={3}>
                {userInfoMsg && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {userInfoMsg}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                身分別：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Select
                  value={master.userType}
                  onChange={selectChange(updateData)}
                  name="userType"
                  options={userTypeList}
                />
              </Grid>
            </Grid>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                使用者名稱：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  disabled
                  maxLength={35}
                  value={master.userName}
                  name="userName"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <Grid container className="button-area">
            <VcEGrid item xs={12} sm={2}>
              <Button
                disabled={formError}
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<SearchIcon />}
                onClick={() => setSubmitKey('edit')}
              >
                查詢
              </Button>
            </VcEGrid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="outlined"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={() => handleReset()}
              >
                重置
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                disabled={formError}
                type="submit"
                variant="contained"
                color="default"
                startIcon={<AddIcon />}
                onClick={() => setSubmitKey('add')}
              >
                新增
              </Button>
            </Grid>
          </Grid>
        </form>
        {openSearchTable && (
          <Table
            key={randomValue}
            data={rowData as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          />
        )}
      </div>
      <UserListModal
        onConfirm={() => {
          getUserType();
        }}
        _open={[openAspModal, setOpenAspModal]}
        optionList={userInfoList}
      />
    </>
  );
};

export default AspUserMtn;
